import { render } from "./PopupMatMaKyLenh.vue?vue&type=template&id=2124da94"
import script from "./PopupMatMaKyLenh.vue?vue&type=script&lang=js"
export * from "./PopupMatMaKyLenh.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__